/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { B as Buttons, d as defineCustomElement$1 } from './p-BBFQmhcD.js';

const IonButtons = Buttons;
const defineCustomElement = defineCustomElement$1;

export { IonButtons, defineCustomElement };
